module.exports = __webpack_public_path__ + "static/media/bay2022FeaturesBanner_Mobile_411x93px_@1x.7016aee1.jpg";